// Imagini mai mici pe telefon, pentru încărcare rapidă (LCP).
//
// - Unsplash redimensionează pe server: cerem direct lățimea potrivită.
// - Imaginile locale din MOBILE_VARIANT_DIRS au o variantă "<nume>-800w.<ext>"
//   generată la build de scripts/image-variants.js (doar în build/, nu în public/).

export const MOBILE_WIDTH = 800;

// Trebuie să corespundă cu folderele din scripts/image-variants.js
const MOBILE_VARIANT_DIRS = [
  "/images/header-medium/",
  "/images/header-blog/",
  "/images/newImages/",
];

const IS_PRODUCTION = process.env.NODE_ENV === "production";

export const unsplashAt = (url, width, quality = 70) => {
  const u = new URL(url.trim());
  u.searchParams.set("w", String(width));
  u.searchParams.set("q", String(quality));
  u.searchParams.set("auto", "format");
  return u.toString();
};

const hasMobileVariant = (url) =>
  IS_PRODUCTION && MOBILE_VARIANT_DIRS.some((dir) => url.includes(dir));

// URL-ul variantei de 800px (sau URL-ul original, dacă nu există variantă)
export const mobileImage = (url) => {
  if (!url) return url;
  if (url.includes("images.unsplash.com")) return unsplashAt(url, MOBILE_WIDTH);
  if (hasMobileVariant(url)) {
    return url.replace(/(\.[a-z]+)$/i, `-${MOBILE_WIDTH}w$1`);
  }
  return url;
};

const desktopImage = (url) =>
  url.includes("images.unsplash.com") ? unsplashAt(url, 1600) : url.trim();

// Fundal responsive pentru Chakra (bgImage / backgroundImage):
// imagine de 800px pe telefon, imaginea mare de la 48em (768px) în sus
export const responsiveBg = (url) => ({
  base: `url("${mobileImage(url)}")`,
  md: `url("${desktopImage(url)}")`,
});
